// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Compromissosadm_RecordsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for /compromissosadm/records
 * Returns an array of compromissos with enriched properties for admin view
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Compromissosadm_RecordsResponseDados {
items: unknown[]
}

export type Compromissosadm_RecordsResponse = ApiResponse<Compromissosadm_RecordsResponseDados>;

registerResponseContract('Compromissosadm_RecordsResponse', {
  items: { type: 'array',   required: true },
})
